export class RegisterClass {
    title:string;
    first_name:string;
    last_name:string;
    email:string;
    mobile_no:string;
    address1:string;
    address2:string;
    address3:string;
    city:string;
    province:string;
    country:string;
    password:string;
    password_confirmation:string;
    cid:string;
    utmString:string;
    register_type:string='';
}